import { Like, Reply } from 'web-shared/src/types/bsky';
import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { skeleton } from '../old/utils';
import { randomFlag } from '../lib/randomFlag';
import { getPostThread, postToPlainText } from '../lib/bsky';

export class BskyComments extends HTMLElement {
  constructor() {
    super();
  }

  Post = (reply: Reply) => {
    const postRecord = reply.post;

    const postId = postRecord.uri.split('/').pop();
    let postText = postToPlainText(postRecord);

    const replies = reply.replies?.map(this.Post);

    return (
      <div className="thread">
        <div className="comment">
          <div className="content">
            <p className="commentHeader">
              💬
              <div className="avatar">
                <img
                  src={
                    postRecord.author.avatar ||
                    randomFlag(postRecord.author.handle)
                  }
                  alt={postRecord.author.handle}
                />
              </div>
              <a
                href={
                  postId
                    ? `https://bsky.app/profile/${reply.post.author.handle}/post/${postId}`
                    : `https://bsky.app/profile/${reply.post.author.handle}/`
                }
                target="_blank"
                rel="noreferrer"
                className="author"
              >
                {postRecord.author.displayName || postRecord.author.handle}
              </a>
              <span className="date">
                {new Date(postRecord.record.createdAt).toLocaleString()}
              </span>
            </p>
            <p className="commentBody">
              {...postText.split('\n').map((chunk) => <div>{chunk}</div>)}
            </p>
            {reply.post.embed?.$type === 'app.bsky.embed.images#view' ? (
              <div className="comment-image">
                {...reply.post.embed.images.map((img) => (
                  <img src={img.fullsize} alt={img.alt} />
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        {replies?.length ? <div className="replies">{...replies}</div> : ''}
      </div>
    );
  };

  Like = (like: Like) => (
    <div className="like">
      ❤️
      <div className="avatar">
        <img
          src={like.actor.avatar || randomFlag(like.actor.handle)}
          alt={like.actor.handle}
        />
      </div>
      <div className="content">
        <p>
          <a
            href={`https://bsky.app/profile/${like.actor.handle}/`}
            target="_blank"
            rel="noreferrer"
            className="author"
          >
            {like.actor.displayName.length > 0
              ? like.actor.displayName
              : like.actor.handle}
          </a>
          &nbsp;Liked this at {new Date(like.createdAt).toLocaleString()}
        </p>
      </div>
    </div>
  );

  getData = async () => {
    const ATURI = encodeURI(
      `at://did:plc:lpxtxymhlfbs5foxba7mfewt/app.bsky.feed.post/${this.dataset.postId}`,
    );

    const result = await getPostThread(ATURI);

    if (result.isErr()) {
      console.error(result.error);
      return [];
    }

    const { replies, likes } = result.value;

    return [...(replies || []), ...(likes || [])].sort(
      (a, b) =>
        new Date(
          'post' in b ? b.post.record.createdAt : b.createdAt,
        ).getTime() -
        new Date('post' in a ? a.post.record.createdAt : a.createdAt).getTime(),
    );
  };

  render = async () => {
    this.append(skeleton('100%', '100px'));

    const interactions = await this.getData();

    this.innerHTML = '';
    this.append(<hr />);
    this.append(
      <p>
        Discuss on&nbsp;
        <a
          className="externalLink"
          target="_blank"
          href={`https://bsky.app/profile/pfy.ch/post/${this.dataset.postId}`}
        >
          Bluesky
        </a>
        &nbsp;/&nbsp;
        <a
          className="externalLink"
          target="_blank"
          href={`https://witchsky.app/profile/pfy.ch/post/${this.dataset.postId}`}
        >
          Witchsky
        </a>
      </p>,
    );
    this.append(
      ...interactions.map((item) =>
        'post' in item ? this.Post(item) : this.Like(item),
      ),
    );

    // Shift footnotes if present
    const parent = this.parentElement;
    const footNoteElement = parent?.nextElementSibling;
    if (footNoteElement && footNoteElement?.className === 'footnotes') {
      parent?.parentElement?.insertBefore(footNoteElement, parent);
    }
  };

  connectedCallback() {
    void this.render();
  }
}
